import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AgenteDto } from '../dto/justino/agente.dto';
import { environment } from '../../environments/environment';
import { Constants } from '../constants/constants';
import { UtilService } from './util.service';

@Injectable({
  providedIn: 'root'
})
export class AgenteService {

  private apiUrl = `${environment.justinoApiUrl}/api/agentes/`;

  constructor(private http: HttpClient) {}

  getHeaders() {
    const authToken = sessionStorage.getItem(Constants.ACCESS_TOKEN) ?? '';
    return { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
    };
  }

  getAgentes(): Observable<AgenteDto[]> {
    return this.http.get<AgenteDto[]>(this.apiUrl, { headers: this.getHeaders() });
  }

  getAgenteById(id: string): Observable<AgenteDto> {
    return this.http.get<AgenteDto>(`${this.apiUrl}${id}`, { headers: this.getHeaders() });
  }

  createAgente(Agente: AgenteDto): Observable<AgenteDto> {
    return this.http.post<AgenteDto>(this.apiUrl, Agente, { headers: this.getHeaders() });
  }

  updateAgente(id: string, Agente: AgenteDto): Observable<AgenteDto> {
    return this.http.put<AgenteDto>(`${this.apiUrl}${id}`, Agente, { headers: this.getHeaders() });
  }

  deleteAgente(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}${id}`, { headers: this.getHeaders() });
  }
}
